/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback } from 'react';
import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { SubmitButton } from '../../pages/common/forms/SubmitButton';
import { ConnectedDialog } from '../ConnectedDialog';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { IMeetingArchiveNoteFormDialogProps } from './types';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { meetingArchiveSelectors } from '../../../app/resource/meeting-archives/meeting-archives.selectors';
import { IMeetingArchive } from '../../../app/resource/meeting-archives/meeting-archives.types';
import { MeetingArchiveNoteForm } from '../../pages/common/forms/MeetingArchiveNoteForm';

export const MeetingArchiveNoteFormDialog: FunctionComponent<IMeetingArchiveNoteFormDialogProps> = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'meetingArchiveNoteFormDialog',
  ) as IMeetingArchiveNoteFormDialogProps;

  const sessionId = props ? props.sessionId : undefined;
  const archive = useSelectWithParams(meetingArchiveSelectors.selectResourceById, sessionId ?? '') as IMeetingArchive;

  const onClose = useCallback(() => {
    dispatch(closeDialog('meetingArchiveNoteFormDialog'));
  }, [dispatch]);

  return (
    <ConnectedDialog dialogKey="meetingArchiveNoteFormDialog">
      <div>
        <div className="panel w500">
          <div className="panel-header small-header flex jcsb">
            <h3 className="f-2">{archive && archive.note ? 'Edit' : 'Add'} Meeting Note</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close" />
            </span>
          </div>
          <div className="panel-body">{archive && <MeetingArchiveNoteForm archive={archive} />}</div>
          <div className="panel-footer no-border flex jcr">
            <a className="link blueGray mr-2 close" onClick={onClose}>
              Close
            </a>
            <SubmitButton apiKey="updateSession" formName="meetingArchiveNoteFormDialog-form" text="Send" />
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
